import Script from 'next/script';
import { useRouter } from 'next/router';

export default function PAPComponent() {
  const router = useRouter();
  const utmCampaign =
    router?.query?.utm_campaign === 'pap' ||
    router?.query?.utm_source === 'pap';

  return utmCampaign ? (
    <Script
      id="pap-script"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          function getURLParams(url) {
            const urlObj = new URL(url);
            const params = new URLSearchParams(urlObj.search);
            let paramsObj = {};
            for (const [key, value] of params.entries()) {
              paramsObj[key] = value;
            }
            return paramsObj;
          }
          const queryParams = getURLParams(window.location.href);
          const queryParamsString = JSON.stringify(queryParams);
          let date = new Date();
          date.setTime(date.getTime() + (60 * 24 * 60 * 60 * 1000));
          let expires = "; expires=" + date.toGMTString();
          document.cookie = "pap=" + escape(queryParamsString) + expires + "; path=/";
        `,
      }}
    />
  ) : null;
}
